(() => {
  const bind = () => {
    const menu = document.querySelector('[data-cosmic-menu]');
    if (menu && !menu.dataset.bound) {
      menu.dataset.bound = 'true';
      menu.addEventListener('click', () => {
        const open = menu.getAttribute('aria-expanded') !== 'true';
        menu.setAttribute('aria-expanded', String(open));
        const nav = document.querySelector('[data-cosmic-mobile]');
        if (nav) { nav.hidden = !open; nav.classList.toggle('open', open); }
      });
    }
    document.querySelectorAll('[data-select-media]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => showMedia(button.dataset.selectMedia));
    });
    document.querySelectorAll('[data-cosmic-variant]').forEach(select => {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        const form = select.closest('form'), option = select.selectedOptions[0];
        if (!form || !option) return;
        form.querySelector('[data-live-price]').textContent = option.dataset.price;
        const compare = form.querySelector('[data-live-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !(Number(option.dataset.compareCents) > Number(option.dataset.priceCents));
        const available = option.dataset.available === 'true';
        form.querySelectorAll('[data-cosmic-submit]').forEach(button => {
          button.disabled = !available;
          button.textContent = available ? button.dataset.readyLabel : button.dataset.soldLabel;
        });
        const quantity = form.querySelector('[name=quantity]');
        quantity.min=option.dataset.min || '1'; quantity.step=option.dataset.step || '1';
        if(option.dataset.max) quantity.max=option.dataset.max; else quantity.removeAttribute('max');
        quantity.value=quantity.min;
        const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(null,'',url);
        if (option.dataset.media) showMedia(option.dataset.media);
      });
    });
    document.querySelectorAll('[data-cosmic-carousel]').forEach(carousel => {
      if (carousel.dataset.bound) return;
      carousel.dataset.bound = 'true';
      const slides = [...carousel.querySelectorAll('[data-cosmic-slide]')];
      let current = 0, paused = matchMedia('(prefers-reduced-motion: reduce)').matches, timer;
      const draw = step => { current = (current + step + slides.length) % slides.length; slides.forEach((slide, i) => { slide.hidden = i !== current; }); };
      const pause = carousel.querySelector('[data-carousel-pause]');
      const reset = () => { clearInterval(timer); pause.textContent = paused ? pause.dataset.resume : pause.dataset.pause; if (!paused) timer = setInterval(() => { if (!document.hidden) draw(1); }, 6500); };
      carousel.querySelector('[data-carousel-prev]').addEventListener('click', () => { draw(-1); reset(); });
      carousel.querySelector('[data-carousel-next]').addEventListener('click', () => { draw(1); reset(); });
      pause.addEventListener('click', () => { paused = !paused; reset(); });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(carousel)) clearInterval(timer); });
      reset();
    });
    document.querySelectorAll('[data-cosmic-sticky]').forEach(button => {
      if(button.dataset.bound)return; button.dataset.bound='true';
      button.addEventListener('click',()=>{const form=document.getElementById(button.dataset.cosmicSticky); if(form && !form.querySelector('[data-cosmic-submit]').disabled)form.requestSubmit();else form?.scrollIntoView({behavior:'smooth'});});
    });
    document.querySelectorAll('.cosmic-product-form').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', () => { if (form.checkValidity()) form.querySelector('[data-cosmic-submit]').setAttribute('aria-busy', 'true'); });
    });
  };
  function showMedia(id) {
    document.querySelectorAll('[data-media-id]').forEach(media => {
      media.hidden = media.dataset.mediaId !== id;
      if (media.hidden) media.querySelectorAll('video').forEach(video => video.pause());
    });
    document.querySelectorAll('[data-select-media]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.selectMedia === id)));
  }
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
